import { useState } from 'react';

const whatsAppHooks = () => {
  const [quotationId, setquotationId] = useState(null);
  const [modalWhatsApp, setModalWhatsApp] = useState({
    isVisible: false,
    handleCancel: () => { },
    handleOk: () => { },
  });
  const handleShowModalSendWhatsApp = (idQuotation) => {
    setModalWhatsApp({ isVisible: true, handleCancel: () => setModalWhatsApp({ isVisible: false }) });
    setquotationId(idQuotation);
  };

  return [modalWhatsApp, handleShowModalSendWhatsApp, quotationId];
};

export default whatsAppHooks;
